import {api, apiHelper} from "./api";

export class Item {
	prefix() {
		return "items"
	}

	index(cb, page = 0, limit = 50, sort = 'uid', sortOrder = 'desc') {
		return api.get(`${this.prefix()}?${apiHelper.buildPaginationQuery(page, limit, sort, sortOrder)}`)
	}

	show(uid) {
		return api.get(`${this.prefix()}/${uid}`)
	}

	create(obj) {
		return api.post(`${this.prefix()}`, obj)
	}

	update(uid, obj) {
		return api.put(`${this.prefix()}/${uid}`, obj)
	}
}

export default new Item()